/* REACT */
import React, { Component, useEffect } from "react";

/* IMPORT */
import Title from "../Utils/Headers/Title";
import LoadMask from "../Utils/LoadMask/LoadMask";
import { useRealtimeRefresh } from "../../hooks/useRealtimeRefresh";

/* STYLES */
import Filters from "../Utils/Filters/Filters";
import CardsHeader from "./Cards/CardsHeader";
import CardContainer from "./Cards/CardContainer";
import "./dashboard-filters.css";

const Dashboard = (props) => {
    const {
        dashboardData,
        loader,
        start_date,
        setStartDate,
        end_date,
        setEndDate,
        station,
        setStation,
        emergency_type_id,
        setTypeEmergency,
        getDashboardReport,
        me,
    } = props;

    useEffect(() => {
        setStation(me ? (me.station ? [me.station] : null) : null);

        getDashboardReport();
    }, []);

    // Real-time refresh when a notification is received
    useRealtimeRefresh(() => {
        getDashboardReport();
    });

    return (
        <div className="py-4 px-3">
            <div className="mb-4">
                <Title
                    title={"Dashboard"}
                    subtitle={"Datos Generales"}
                    showCreate={false}
                />
            </div>

            <div className="mb-4 d-flex flex-wrap dashboard-filters-container">
                <Filters
                    startDate={{
                        show: true,
                        start_date: start_date,
                        setStartDate: setStartDate,
                        classNameFilter: "flex-1 m-1",
                    }}
                    endDate={{
                        show: true,
                        end_date: end_date,
                        setEndDate: setEndDate,
                        classNameFilter: "flex-1 m-1",
                    }}
                    station={{
                        show: true,
                        station: station
                            ? station
                            : props.me
                                ? props.me.station
                                : null,
                        setStation: setStation,
                        classNameFilter: "flex-1 m-1",
                    }}
                    emergency_type={{
                        show: true,
                        emergency_type: emergency_type_id,
                        setTypeEmergency: setTypeEmergency,
                        classNameFilter: "flex-1 m-1",
                    }}
                />
            </div>
            <LoadMask loading={loader} blur>
                {dashboardData ? (
                    <div className="dashboard-grid-container">
                        <CardsHeader dashboardData={dashboardData} />
                        <CardContainer
                            dashboardData={dashboardData}
                            loader={loader}
                            start_date={start_date}
                            end_date={end_date}
                            permissions={me.role ? (me.role === 8 || me.role === 1) : false}
                        />
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-12 px-0 d-flex flex-wrap">
                            <h3> No hay estadisticas que mostrar </h3>
                        </div>
                    </div>
                )}
            </LoadMask>
        </div>
    );
};

export default Dashboard;
